import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseCookieManager } from './supabase-cookies';


function getCookieDomain(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const hostname = window.location.hostname;
  if (hostname === "localhost") return undefined;
  return `.${hostname.replace(/^.*?([^.]+\.[^.]+)$/, "$1")}`;
}

let _client: SupabaseClient | null = null;
let _error: string | null = null;

export function getSupabaseClient(): SupabaseClient | null {
  if (_client) return _client;
  if (_error) throw new Error(_error);

  const url = import.meta.env.VITE_SUPABASE_URL;
  if (!url) {
    throw new Error('Missing env: VITE_SUPABASE_URL. Add it to client-v2/.env (see .env.example).');
  }
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  SupabaseCookieManager.fromURL(url).autoCleanUnneededAnonCookies();

  const missing: string[] = [];
  if (!url) missing.push('VITE_SUPABASE_URL');
  if (!key) missing.push('VITE_SUPABASE_ANON_KEY');
  if (missing.length) {
    _error = `Missing env: ${missing.join(', ')}. Add them to client-v2/.env (see .env.example).`;
    throw new Error(_error);
  }

  const domain = getCookieDomain();
  _client = createBrowserClient(url, key, domain ? { cookieOptions: { domain } } : undefined);

  return _client;
}
